let active = null,
  launchTicket = null,
  flow = null,
  stopTimer = null;
export function setAnalyticsLaunch(ticket) {
  launchTicket = typeof ticket === 'string' ? ticket : null;
}
const uuid = () => crypto.randomUUID();
const recentFlow = () =>
  flow && Date.now() - flow.at < 30 * 60000 ? flow.id : null;
export function analyticsHeaders() {
  return active && active.token === localStorage.getItem('polka_token')
    ? {
        ...(active.ready ? { 'X-Polka-Session': active.id } : {}),
        ...(recentFlow() ? { 'X-Polka-Search-Flow': recentFlow() } : {}),
      }
    : {};
}
export function startAnalytics(userId, token, telegram = false) {
  clearTimeout(stopTimer);
  if (active?.userId === userId && active.token === token) return;
  if (active?.timer) clearTimeout(active.timer);
  flow = null;
  active = {
    userId,
    token,
    telegram,
    id: uuid(),
    ready: false,
    queue: [],
    timer: null,
    sending: false,
    clockOffset: 0,
  };
  const state = active;
  if (!telegram) {
    try {
      const old = JSON.parse(
        sessionStorage.getItem(`polka_session_${userId}`) || 'null',
      );
      if (
        old &&
        /^[\da-f-]{36}$/i.test(old.id || '') &&
        Date.now() - old.at < 30 * 60000
      )
        state.id = old.id;
    } catch {
      /* Optional session persistence. */
    }
  }
  const initialize = async () => {
    if (active !== state) return;
    try {
      const started = Date.now();
      const response = await fetch('/api/analytics/session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          session_id: state.id,
          telegram,
          launch_ticket: telegram ? launchTicket : null,
        }),
      });
      if (response.status === 409) {
        state.id = uuid();
        state.timer = setTimeout(initialize, 100);
        return;
      }
      if (!response.ok) throw Error('Unavailable');
      const data = await response.json();
      if (active !== state) return;
      if (!/^[\da-f-]{36}$/i.test(data.id || ''))
        throw Error('Invalid session');
      state.id = data.id;
      state.clockOffset = Number.isFinite(data.server_time)
        ? data.server_time - (started + Date.now()) / 2
        : 0;
      state.ready = true;
      try {
        if (!telegram)
          sessionStorage.setItem(
            `polka_session_${userId}`,
            JSON.stringify({ id: state.id, at: Date.now() }),
          );
      } catch {
        /* Optional. */
      }
      void flushAnalytics();
    } catch {
      if (active === state) state.timer = setTimeout(initialize, 15000);
    }
  };
  void initialize();
}
export function stopAnalytics() {
  clearTimeout(stopTimer);
  stopTimer = setTimeout(() => {
    if (active?.timer) clearTimeout(active.timer);
    void flushAnalytics(true);
    active = null;
    flow = null;
  }, 0);
}
export function beginSearchFlow(queryLength) {
  flow = { id: uuid(), at: Date.now() };
  trackEvent('search_start', { query_length: queryLength });
  return flow.id;
}
export function clearSearchFlow() {
  flow = null;
}
export function selectSearchProject(item, category) {
  if (window.location.pathname === '/search' && recentFlow())
    trackEvent('search_select', {
      category: item.category || category,
      item_id: String(item.external_id ?? item.id),
    });
}
export function trackEvent(name, properties = {}) {
  const state = active;
  if (!state || state.token !== localStorage.getItem('polka_token')) return;
  const { category, item_id, flow_id, ...rest } = properties;
  state.queue.push({
    id: uuid(),
    at: Date.now(),
    name,
    category,
    item_id: item_id == null ? null : String(item_id),
    flow_id: flow_id || recentFlow(),
    properties: rest,
  });
  if (state.queue.length > 300) state.queue.shift();
  if (state.ready && !state.sending) {
    clearTimeout(state.timer);
    state.timer = setTimeout(() => void flushAnalytics(), 400);
  }
}
export async function flushAnalytics(keepalive = false) {
  const state = active;
  if (!state?.ready || state.sending || !state.queue.length) return;
  state.sending = true;
  const batch = state.queue.splice(0, 30);
  try {
    const response = await fetch('/api/analytics/events', {
      method: 'POST',
      keepalive,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${state.token}`,
      },
      body: JSON.stringify({
        session_id: state.id,
        events: batch.map((row) => ({
          ...row,
          at: Math.round(row.at + state.clockOffset),
        })),
      }),
    });
    if (!response.ok) throw Error('Unavailable');
  } catch {
    state.queue.unshift(...batch);
  } finally {
    state.sending = false;
    if (active === state && state.queue.length && !keepalive) {
      clearTimeout(state.timer);
      state.timer = setTimeout(() => void flushAnalytics(), 5000);
    }
  }
}
if (
  typeof window !== 'undefined' &&
  typeof window.addEventListener === 'function'
) {
  window.addEventListener('pagehide', () => void flushAnalytics(true));
  window.addEventListener('online', () => void flushAnalytics());
}
